import { Validators } from '@angular/forms';
import { ApplicationStatusEnum } from '@tran-monorepo/interfaces/applications/enums/application-status.enum';
import { ApplicationDetailForm } from '../application-detail.form';

export const DATE_ORDER_ERROR_KEY = 'startDateBeforeEndDate';

export function setApprovedBudgetMandatoryIfStatusIsApproved(
    detailForm: ApplicationDetailForm,
    formValue: Partial<ApplicationDetailForm['value']>
): void {
    const status = formValue.status?.status;
    const approvedBudgetControl = detailForm.get('approvedBudget');
    if (status === ApplicationStatusEnum.Approved) {
        approvedBudgetControl?.setValidators([Validators.required]);
    } else {
        approvedBudgetControl?.removeValidators([Validators.required]);
    }
    approvedBudgetControl?.updateValueAndValidity({ emitEvent: false });
}

export function setCommitteeProtocolMandatoryIfStatusIsApproved(
    detailForm: ApplicationDetailForm,
    formValue: Partial<ApplicationDetailForm['value']>
): void {
    const status = formValue.status?.status;
    const committeeProtocolControl = detailForm.get('committeeProtocol');
    if (status === ApplicationStatusEnum.Approved) {
        committeeProtocolControl?.setValidators([Validators.required]);
    } else {
        committeeProtocolControl?.clearValidators();
    }
    committeeProtocolControl?.updateValueAndValidity({ emitEvent: false });
}

export function setStartDateBeforeEndDateValidation(
    detailForm: ApplicationDetailForm,
    formValue: Partial<ApplicationDetailForm['value']>
): void {
    const startDateControl = detailForm.get('startDate');
    const endDateControl = detailForm.get('endDate');

    const startDate = formValue.startDate;
    const endDate = formValue.endDate;

    if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
        clearControlError(startDateControl, DATE_ORDER_ERROR_KEY);
        clearControlError(endDateControl, DATE_ORDER_ERROR_KEY);
        return;
    }

    const isInvalidDateOrder = startDate.getTime() >= endDate.getTime();
    if (isInvalidDateOrder) {
        setControlError(startDateControl, DATE_ORDER_ERROR_KEY);
        setControlError(endDateControl, DATE_ORDER_ERROR_KEY);
        return;
    }

    clearControlError(startDateControl, DATE_ORDER_ERROR_KEY);
    clearControlError(endDateControl, DATE_ORDER_ERROR_KEY);
}

function setControlError(control: ReturnType<ApplicationDetailForm['get']>, errorKey: string): void {
    if (!control) {
        return;
    }

    const currentErrors = control.errors ?? {};
    if (currentErrors[errorKey]) {
        return;
    }

    control.setErrors({ ...currentErrors, [errorKey]: true });
}

function clearControlError(control: ReturnType<ApplicationDetailForm['get']>, errorKey: string): void {
    if (!control?.errors?.[errorKey]) {
        return;
    }

    const { [errorKey]: _, ...remainingErrors } = control.errors;
    control.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
}
